// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Bk2Z","inner":"Footer_inner__12zB_","nextIcon":"Footer_nextIcon__2q1BI","innerLeft":"Footer_innerLeft__2cyA_"};